import { zodResolver } from '@hookform/resolvers/zod'
import { useContext } from 'react'
import { useForm } from 'react-hook-form'
import z from 'zod'

import { getValueAsArray } from '@hap/analytics'
import { Button, Form, FormFieldMultiline } from '@hap/components'

import { FilterContext } from '../filter-context'

export function ExternalIdFilterControl() {
  const { onSelect, filter } = useContext(FilterContext)
  const values = getValueAsArray(filter)
  const form = useForm({
    resolver: zodResolver(schema),
    values: {
      ids: values.join(', '),
    },
  })

  const onSubmit = form.handleSubmit((data) => {
    onSelect({
      op: 'in',
      values: data.ids
        .replace(/,$/, '')
        .split(/[,\n]+/)
        .map((v) => v.trim())
        .filter((v) => v.length > 0),
      field: 'externalId',
    })
  })

  return (
    <Form {...form}>
      <form onSubmit={onSubmit}>
        <div className="grid gap-1 p-2">
          <FormFieldMultiline
            control={form.control}
            name="ids"
            maxRows={5}
            placeholder="Enter external IDs separated by commas or line breaks"
          />
          <Button type="submit" icon="check" size="sm" className="shrink-0" />
        </div>
      </form>
    </Form>
  )
}

const schema = z.object({
  ids: z.string(),
})
